/* eslint-disable camelcase */
import { put, call, fork, takeLeading, takeLatest } from 'redux-saga/effects';
import {
  GET_WALLET_SUMMARY,
  GET_WALLET_TRANSACTIONS,
  POST_WALLET_APPLY,
  POST_WALLET_REMOVE
} from '../actionTypes';
import {
  WALLET_SUMMARY_API,
  WALLET_TRANSACTIONS_API,
  WALLET_APPLY,
  WALLET_REMOVE
} from '../../constants/api-constants';

import * as API from '../../utils/ajax';
import * as Actions from './actions';

function* getWalletSummaryAsync(action) {
  try {
    const response = yield call(
      API.get,
      `${WALLET_SUMMARY_API}?${action?.value}`
    );
    if (typeof action.meta === 'function') action.meta();
    yield put(Actions.getWalletSummarySuccess(response, action));
    yield put(Actions.updateWalletAmount(response, action));
  } catch (error) {
    if (typeof action.meta === 'function') action.meta();
    yield put(Actions.getWalletSummaryFailure(error, action));
  }
}

function* getWalletTransactionsAsync(action) {
  try {
    const response = yield call(
      API.get,
      `${WALLET_TRANSACTIONS_API}?${action?.value}`
    );

    yield put(Actions.getWalletTransactionsSuccess(response, action));
  } catch (error) {
    yield put(Actions.getWalletTransactionsFailure(error, action));
  }
}

function* postWalletApplyAsync(action) {
  try {
    const response = yield call(API.post, WALLET_APPLY, action.value);

    if (typeof action?.meta?.success === 'function') action.meta.success();
    yield put(Actions.postWalletApplySuccess(response, action));
  } catch (error) {
    yield put(Actions.postWalletApplyFailure(error, action));
  }
}

function* postWalletRemoveAsync(action) {
  try {
    const response = yield call(API.post, WALLET_REMOVE, action.value);

    if (typeof action?.meta?.success === 'function') action.meta.success();
    yield put(Actions.postWalletRemoveSuccess(response, action));
  } catch (error) {
    yield put(Actions.postWalletRemoveFailure(error, action));
  }
}

export function* watchWalletSaga() {
  yield takeLeading(GET_WALLET_SUMMARY, getWalletSummaryAsync);
  yield takeLeading(GET_WALLET_TRANSACTIONS, getWalletTransactionsAsync);
  yield takeLatest(POST_WALLET_APPLY, postWalletApplyAsync);
  yield takeLatest(POST_WALLET_REMOVE, postWalletRemoveAsync);
}
const walletSaga = [fork(watchWalletSaga)];
export default walletSaga;
